import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { IIntervalsFactResponse, IIntervalsInStore, IIntervalsPlanResponse } from "./types";

import { intervalsStoreUtils } from "./utils";

interface IntervalsState {
  invalidationKey: number;
  loadings: Record<string, boolean>;
  intervals: Record<string, IIntervalsInStore>;
}

export const initialState: IntervalsState = {
  invalidationKey: 0,
  loadings: {},
  intervals: {},
};

const intervalsSlice = createSlice({
  name: "intervals",
  initialState,
  reducers: {
    invalidateKey: (state) => {
      state.invalidationKey++;
    },
    setIsLoading: (state, action: PayloadAction<{ status: boolean; key: string }>) => {
      const { status, key } = action.payload;
      state.loadings[key] = status;
    },
    setIntervals: (
      state,
      action: PayloadAction<{
        intervals: Partial<IIntervalsFactResponse> & Partial<IIntervalsPlanResponse>;
        key: string;
      }>
    ) => {
      const { intervals, key } = action.payload;
      state.intervals[key] = {
        ...(state.intervals[key] ?? {}),
        ...intervalsStoreUtils.prepareIntervalsForStoring(intervals),
      };
    },
  },
});

export const intervalsActions = intervalsSlice.actions;

export const intervalsReducer = intervalsSlice.reducer;
